const defaultState = () => {
	return {
		isActive: false,
	}
}

export const state = () => defaultState()

export const mutations = {
	setIsLcqActive(state, isLcqActive) {
		state.isActive = isLcqActive
	},
}

export const actions = {}

export const getters = {
	isLcqActive(state) {
		return state.isActive
	},
}
